<script setup>
import { computed, onMounted } from 'vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useWebCall } from 'dashboard/composables/useWebCall';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  conversationId: { type: Number, required: true },
});

const store = useStore();
const appIntegrations = useMapGetter('integrations/getAppIntegrations');

// Either engine makes web calls available — an account that has moved to Agora
// has no dyte hook at all, and the server picks between them (Voice::Web::Engine).
const WEB_CALL_INTEGRATIONS = ['dyte', 'agora'];

const isWebCallEnabled = computed(() =>
  appIntegrations.value.some(
    integration =>
      WEB_CALL_INTEGRATIONS.includes(integration.id) && integration.hooks.length
  )
);

onMounted(() => {
  if (!appIntegrations.value.length) store.dispatch('integrations/get');
});

const { start, isStarting } = useWebCall();
const startCall = () => start(props.conversationId);
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <NextButton
    v-if="isWebCallEnabled"
    v-tooltip.top-end="$t('CONVERSATION.WEB_CALL.START')"
    :aria-label="$t('CONVERSATION.WEB_CALL.START')"
    icon="i-ph-headset"
    slate
    faded
    sm
    :is-loading="isStarting"
    @click="startCall"
  />
</template>
